import React from 'react';
import { Box } from '@mui/material';
import { getLevelColor, rgba } from './patternSuperGroups';

/**
 * Progress bar + ratio: `<learned> / <total>`.
 * Used on every card (Pattern, Form, Family, Level) to show user progress.
 */
export const ProgressBadge: React.FC<{ learned: number; total: number; width?: number }> = ({
  learned,
  total,
  width = 64,
}) => {
  const pct = total > 0 ? Math.round((learned / total) * 100) : 0;
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
      <Box
        sx={{
          width,
          height: 6,
          borderRadius: 999,
          bgcolor: 'primary.body',
          overflow: 'hidden',
          flex: 'none',
        }}
      >
        <Box
          sx={{
            width: `${pct}%`,
            height: '100%',
            bgcolor: '#5FA56F',
            borderRadius: 999,
          }}
        />
      </Box>
      <Box component="span" sx={{ fontSize: 12.5, color: 'text.secondary', whiteSpace: 'nowrap' }}>
        <Box component="b" sx={{ color: 'text.primary', fontWeight: 700 }}>
          {learned}
        </Box>
        /{total}
      </Box>
    </Box>
  );
};

/**
 * CEFR-coloured pill (A1/A2/B1/B2/C1/C2). Used in the verbs table and on Level cards.
 */
export const LevelPill: React.FC<{ level: string }> = ({ level }) => {
  const color = getLevelColor(level);
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 30,
        height: 22,
        px: 1,
        borderRadius: 0.75,
        fontSize: 12,
        fontWeight: 800,
        letterSpacing: '0.02em',
        bgcolor: rgba(color, 0.13),
        color,
      }}
    >
      {level}
    </Box>
  );
};
